import { get } from 'lodash';
export var sliceColorInfo = function (entity, options) {
  var color = get(entity, 'color.value', 'strong');
  var backgroundColor = get(entity, 'backgroundColor.value', 'canvas');
  var themeMode = get(entity, 'themeMode.slug');
  var isInverted = themeMode === 'dark';
  return {
    color: color,
    backgroundColor: backgroundColor,
    isInverted: isInverted
  };
};